import { useEffect } from "react";

const useClickOutside = (refs, onClickOutside) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutside = refs?.every(
        (ref) => ref?.current && !ref?.current?.contains(event.target)
      );
      if (isOutside) {
        onClickOutside();
      }
    };

    document.addEventListener("click", handleClickOutside, true);

    // Cleanup event listener on unmount
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [refs, onClickOutside]);
};

export default useClickOutside;
